//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["part","deformComponent"],"CreateDeformBuilder",{R_:{builder:"Assemblies.DeformBuilder"}},2,0],[["partOcc","targetPart","isReplaceMode"],"PreProcessDefinitionPart",{R_:{reopenedPart:"Part"}},3,0],[["oldReplacedFlexName"],"PostProcessReplaceFlexFeature",{},1,0],[["oldFlex"],"DeleteReplacedFeature",{},1,0],[["isReplacingDeformation"],"SetReplaceDeformMode",{R_:{oldDeformationState:''}},1,0],[["part"],"LoadOccurrenceData",{},1,0]],[]];
SPLM.Assemblies.DeformManager = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.DeformManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;